export const COMPACT_VIEW_STORAGE_KEY = "b3os-compact-view";
export const DEFAULT_COMPACT_VIEW = true;

export const WORKFLOW_VERTICAL_GAP_COMPACT = 50;
export const WORKFLOW_VERTICAL_GAP_EXPANDED = 100;

export const PREVIEW_VERTICAL_GAP_COMPACT = 50;
export const PREVIEW_VERTICAL_GAP_EXPANDED = 65;

export function readStoredCompactViewPreference(defaultValue = DEFAULT_COMPACT_VIEW): boolean {
  if (typeof window === "undefined") {
    return defaultValue;
  }

  try {
    const stored = localStorage.getItem(COMPACT_VIEW_STORAGE_KEY);
    return stored === null ? defaultValue : stored === "true";
  } catch {
    return defaultValue;
  }
}

export function writeStoredCompactViewPreference(nextValue: boolean): void {
  try {
    localStorage.setItem(COMPACT_VIEW_STORAGE_KEY, String(nextValue));
  } catch {}
}

export function getWorkflowVerticalGap(isCompact: boolean): number {
  return isCompact ? WORKFLOW_VERTICAL_GAP_COMPACT : WORKFLOW_VERTICAL_GAP_EXPANDED;
}

export function getPreviewVerticalGap(isCompact: boolean): number {
  return isCompact ? PREVIEW_VERTICAL_GAP_COMPACT : PREVIEW_VERTICAL_GAP_EXPANDED;
}
